<nz-radio-group
  class="radio-group-table"
  [ngModel]="selectedKey()"
  (ngModelChange)="onSelectChange($event)"
  [nzDisabled]="!selectionEnabled()"
>
  <nz-table
    [nzData]="groupedRanges()"
    [nzLoading]="loading()"
    [nzShowPagination]="false"
  >
    <thead>
      <tr>
        <th></th>
        <th>Range/Element</th>
        <th
          [nzSortFn]="true"
          [nzSortOrder]="sortOrder('blockCount')"
          (nzSortOrderChange)="handleSortOrderChange('blockCount', $event)"
        >
          Block #
        </th>
        <th
          [nzSortFn]="true"
          [nzSortOrder]="sortOrder('capacity')"
          (nzSortOrderChange)="handleSortOrderChange('capacity', $event)"
        >
          Capacity (Ah)
        </th>
        <th
          [nzSortFn]="true"
          [nzSortOrder]="sortOrder('backupTime')"
          (nzSortOrderChange)="handleSortOrderChange('backupTime', $event)"
        >
          Expected backup time (minutes)
        </th>
        <th
          [nzSortFn]="true"
          [nzSortOrder]="sortOrder('price')"
          (nzSortOrderChange)="handleSortOrderChange('price', $event)"
        >
          Price est. (EUR)
        </th>
      </tr>
    </thead>
    <tbody>
      @for (group of groupedRanges(); track group.rangeCode) {
        <tr class="group-header">
          <td colspan="6">
            {{ group.rangeCode }} - {{ group.rangeName || '-' }}
          </td>
        </tr>
        @for (item of visibleItems(group); track item._key; let i = $index) {
          @if (item.status === statuses.Infeasible) {
            <tr class="row-infeasible">
              <td colspan="6">
                <nz-alert
                  nzType="warning"
                  nzShowIcon
                  [nzMessage]="resolveInfeasibleMessage(item.reason)"
                ></nz-alert>
              </td>
            </tr>
          } @else {
            @let config = item.configuration;
            <tr
              class="results-table__selectable-row"
              tabindex="0"
              [class.row-even]="(i + 1) % 2 === 0"
              [class.row-selected]="selectedKey() === item._key"
              (click)="selectItem(item._key)"
              (keydown.enter)="selectItem(item._key)"
              (keydown.space)="selectItem(item._key); $event.preventDefault()"
            >
              <td>
                <label
                  nz-radio
                  [nzValue]="item._key"
                  [nzDisabled]="!selectionEnabled()"
                ></label>
              </td>
              <td>
                {{ config?.batteryPartNumber ?? '-' }}
              </td>
              <td>
                {{
                  config
                    ? config.parallels > 1
                      ? config.parallels + ' x ' + config.seriesBlocks
                      : config.seriesBlocks
                    : '-'
                }}
              </td>
              <td>
                {{ capacityLabel(config) }}
              </td>
              <td>
                {{ config?.realBackupMinutes ?? '-' }}
              </td>
              <td>
                @if (
                  item.batteryTotalPrice !== null &&
                  item.batteryTotalPrice !== undefined
                ) {
                  {{ item.batteryTotalPrice | number: '1.2-2' }}
                } @else {
                  -
                }
              </td>
            </tr>
          }
        }
        @if (canToggleRange(group)) {
          <tr class="range-toggle-row">
            <td colspan="6">
              <button
                nz-button
                nzType="link"
                type="button"
                (click)="toggleRange(group.rangeCode)"
              >
                <span nz-icon [nzType]="rangeToggleIcon(group)"></span>
                {{ rangeToggleLabel(group) }}
              </button>
            </td>
          </tr>
        }
      }
    </tbody>
  </nz-table>
</nz-radio-group>
